import { render, staticRenderFns } from "./CardLockersOfUser.vue?vue&type=template&id=6fb7cdd5&"
import script from "./CardLockersOfUser.vue?vue&type=script&lang=js&"
export * from "./CardLockersOfUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports